export default __webpack_public_path__ + "static/media/revicons.e8746a62.woff";